import { fetchRequest } from "../../utils/axiosConfig";

export const GET_PING = "GET_PING";

export const ping = () => (dispatch) => {
  return fetchRequest("/api/ping", null, "GET")
    .then(({ data }) => {
      dispatch({
        type: GET_PING,
        payload: data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
